<template>
  <div class="inspectionIncomingDetailEdit">
    <el-dialog
        :visible.sync="dialogVisibleIncomingDetail"
        :title="inspectionReport.pkid > 0 ? '质量检验编辑':'质量检验新建'"
        width="1400px"
        top="10vh"
        append-to-body
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          style="position: relative"
          :model="inspectionReport"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="物料号：">
              <el-input v-model="inspectionReport.materialNo"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="物料描述：">
              <el-input v-model="inspectionReport.materialName"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="供应商：">
              <el-input v-model="inspectionReport.supplierName" placeholder="请选择" readonly>
                <el-button slot="append" icon="el-icon-search" @click="$refs.supplierSelect.open()"/>
              </el-input>
              <supplier-select ref="supplierSelect" @select="onSelectSupplier"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="基准：">
              <el-input v-model="inspectionReport.standards"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="实际：">
              <el-input v-model="inspectionReport.practical"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="问题分类：">
              <el-select
                  v-model.trim="inspectionReport.problemClassification"
                  clearable
                  placeholder="请选择">
                <el-option
                    v-for="item in constants.problemClassification_LL.$options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
              <el-select
                  v-if="inspectionReport.storageInspectionType === 20"
                  v-model.trim="inspectionReport.problemClassification"
                  clearable
                  placeholder="请选择">
                <el-option
                    v-for="item in constants.problemClassification_RJ.$options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="问题初步调查：">
              <el-input v-model="inspectionReport.preliminaryInvestigation" type="textarea"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="实际不良总数：" :span="8">
              <el-input v-model="inspectionReport.badQuality" type="number" min="1"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="是否处理：">
              <el-radio-group v-model="inspectionReport.needHandle">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="区域负责工程师：">
              <el-input v-model="inspectionReport.regionalManager" placeholder="请选择" readonly>
                <el-button slot="append" icon="el-icon-search" @click="$refs.selectRegionalManager.open()"/>
              </el-input>
              <user-select ref="selectRegionalManager" @select="selectRegionalManager"/>
            </el-form-item>
          </el-col>
          <el-col v-if="inspectionReport.needHandle" :span="8">
            <el-form-item label="处理人：">
              <el-input v-model="inspectionReport.handleName" placeholder="请选择" readonly>
                <el-button slot="append" icon="el-icon-search" @click="$refs.selectHandle.open()"/>
              </el-input>
              <user-select ref="selectHandle" @select="onSelectHandle"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="责任部门接口人：">
              <el-input v-model="inspectionReport.responsibleName" placeholder="请选择" readonly>
                <el-button slot="append" icon="el-icon-search" @click="$refs.selectResponsibleName.open()"/>
              </el-input>
              <user-select ref="selectResponsibleName" @select="onSelectResponsibleName"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="责任部门：">
              <el-input v-model="inspectionReport.responsibleDepartment"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否批次问题：">
              <el-radio-group v-model="inspectionReport.batchProblem">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="检验项目">
          <el-checkbox-group v-model="inspectionReport.inspectionDetailVOS">
            <el-checkbox v-for="item in inspectionReport.inspectionTemplateDetailVOS" :key="item.pkid" :label="item.inspectionName">{{item.inspectionName}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <div>
          <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">检验附件</div>
          <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
            <upload-file
                ref="upload"
                :auth-index="authIndex"
                style="margin-bottom: 10px; float: left"
                @upload-success="uploadSuccess"/>
          </div>
          <el-table
              v-if="inspectionReport.accessoryList"
              ref="payData1"
              :data="inspectionReport.accessoryList">
            <el-table-column type="index" align="center" label="行号"/>
            <el-table-column prop="fileName" align="center" label="图片">
              <template slot-scope="scope">
                <el-image
                    style="width: 50px; height: 50px;margin-right: 10px"
                    :src="scope.row.imgUrl"
                    :preview-src-list="imgUrls"/>
              </template>
            </el-table-column>
            <el-table-column prop="fileName" align="center" label="附件描述">
              <template slot-scope="scope">
                <el-input v-model="scope.row.fileName" class="tabInput" style="width: 400px;margin: 0 auto;text-align: center"/>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
              <template slot-scope="scope">
                <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <span slot="footer">
        <el-button type="info" @click="dialogVisibleIncomingDetail=false">关闭</el-button>
        <el-button type="primary" @click="reportSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import constants from "../../../util/constants";
  import SupplierSelect from "@/views/information/SupplierManage/SupplierSelect";
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";
  import UploadFile from "@/components/UploadFile";
  export default {
    name: "InspectionIncomingDetailEdit",
    components: {UploadFile, UserSelect, SupplierSelect},
    data() {
      return {
        constant,
        constants,
        authIndex: 39,
        imgUrls: [],
        dialogVisibleIncomingDetail: false,
        contentLoading: false,
        index: 0,
        inspectionReport: {
          pkid: 0,
          barCode: "",
          voucherNo: "",
          no: "",
          billID: "",
          billType: "",
          inspectionType: 10,
          storageInspectionType: 30,
          conclusion: 0,
          inspectionResult: false,
          needHandle: true,
          batchProblem: false,
          handleType: 10,
          processMode: "",
          materialNo: "",
          materialName: "",
          handleDepartment: "",
          standards: "",
          practical: "",
          problemClassification: "",
          badQuality: "",
          preliminaryInvestigation: "",
          responsibleDepartment: "",
          responsibleID: "",
          responsibleName: "",
          supplierID: "",
          supplierName: "",
          regionalID: "",
          regionalManager: "",
          handleID: "",
          handleName: "",
          qualitativeClassification: "",
          createdTime: "",
          inspectorName: "",
          accessories: [],
          inspectionMaterials: [],
          accessoryList: [],
          countersignVOS: [],
          inspectionTemplateDetailVOS: [],
          inspectionDetailVOS: ["A:包装","B:标识","C:外观","D:规格型号"],
        },
        ruleValidate: {
          regionalManager: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row,index) {
        this.dialogVisibleIncomingDetail = true;
        console.log(row, index);
        this.inspectionReport.pkid = row.pkid;
        this.index = index;
        if (this.inspectionReport.pkid > 0) {
          this.getData();
        }else {
          this.inspectionReport = row;
        }
      },
      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
            imgUrl: "",
          };
          this.$http.get("basic", `files/getDownloadUrl?key=${params.filePath}`).then((res) => {
            if (res.success) {
              params.imgUrl = res.data;
              this.imgUrls.push(params.imgUrl);
            }
          });
          this.inspectionReport.accessoryList.push(params);
        }
      },
      fileDelete(row,index) {
        this.inspectionReport.accessoryList.splice(index, 1);
      },
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `inspectionReports/selectReportByPKID/${this.inspectionReport.pkid}`)
          .then(resp => {
            console.log(resp);
            this.inspectionReport = resp.data;
            this.inspectionReport.accessoryList.forEach(row => {
              this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
                if (res.success) {
                  row.imgUrl = res.data;
                  this.imgUrls.push(row.imgUrl);
                }
              });
            });
            this.contentLoading = false;
          });
      },
      selectRegionalManager(row) {
        this.inspectionReport.regionalID = row.systemUserID;
        this.inspectionReport.regionalManager = row.employeeName;
      },
      onSelectHandle(row) {
        this.inspectionReport.handleID = row.systemUserID;
        this.inspectionReport.handleName = row.employeeName;
      },
      onSelectSupplier(row) {
        this.inspectionReport.supplierID = row.pkid;
        this.inspectionReport.supplierName = row.name;
      },
      onSelectResponsibleName(row) {
        this.inspectionReport.responsibleID = row.systemUserID;
        this.inspectionReport.responsibleName = row.employeeName;
        this.inspectionReport.responsibleDepartment = row.departmentName;
      },
      reportSave() {
        this.$emit("save-success", this.inspectionReport,this.index);
        this.dialogVisibleIncomingDetail = false;
      },
    },
  };
</script>

<style lang="scss">
  .inspectionIncomingDetailEdit {
    .table {
      width: 100%;
      margin: 2% auto;
      border-top: 1px solid #dddddd;
      border-left: 1px solid #dddddd;

      .tableLabel {
        width: 130px;
        padding: 1%;
        background: #f4f7fa;
        border-bottom: 1px solid #dddddd;
      }

      .tableModel {
        width: 20%;
        padding: 1%;
        border-left: 1px solid #dddddd;
        border-right: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;
      }
    }
  }

</style>
